import React from "react"

const Component = ({ address }) => {
  return (
    <iframe
      src={`https://maps.google.co.jp/maps?output=embed&q=${address}&z=15`}
      width="100%"
      height="450"
      frameborder="0"
      style={{ border: 0, marginBottom: "-0.5rem" }}
      allowfullscreen
      loading="lazy"
      title={`Google Map: ${address}`}
    />
  )
}

export default Component
